import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { usePrivate } from "../contexts/PrivateInfoContext";
import { formatCurrency } from "../utils/FormatCurrency";

function ProtestoDialog({ close, aceiteProtesto }) {
  const { taxaEnvioProtesto, taxaPrimeiraParcelaProtesto } = usePrivate();
  const [emailConfirmacao, setEmailConfirmacao] = useState("");
  const [checkedProtesto, setCheckedProtesto] = useState(false);

  function dialogProtestoFooter() {
    return (
      <div className="mt-[2vh] grid gap-[5vh] font-lato">
        <div className="continueButton w-full grid px-[20%]">
          <Button
            className="continueButton w-3/4"
            onClick={() => aceiteProtesto(emailConfirmacao)}
            label="Aceito"
            disabled={!checkedProtesto || emailConfirmacao === ""}
          ></Button>
        </div>
      </div>
    );
  }

  return (
    <Dialog
      header="Cobranças Protestadas"
      draggable={false}
      className="boletosDialog card"
      onHide={() => close()}
      visible
      footer={dialogProtestoFooter}
      style={{
        maxWidth: window.innerWidth > 760 ? "60vw" : "100vw",
        minHeigth: "30vh",
        minWidth: "20vh",
        textAlign: "center",
        // borderRadius: '30px',
        // padding: '10px'
      }}
    >
      <div className="font-lato">
        <h6 className="p-5 text-slate-700 ">
          Estou ciente que para baixa efetiva de Protesto junto ao cartório, será necessário antes liquidar as taxas do
          protesto através de boleto de custas, o qual será gerado após a realização do pagamento total ou parcial da
          dívida
          {(taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0) > 0 && (
            <span className="font-lato-bold">
              , além de receber um acréscimo de{" "}
              {formatCurrency(Number(taxaPrimeiraParcelaProtesto ? taxaEnvioProtesto : 0))}
              &nbsp;pela taxa de envio a protesto, que será adicionado ao valor total do primeiro boleto.
            </span>
          )}
        </h6>
        <div className="grid p-fluid mt-3 py-[2vh] lg:px-[10%]">
          <span className="p-float-label">
            <InputText
              value={emailConfirmacao}
              onChange={(e) => setEmailConfirmacao(e.target.value)}
              id="email"
              type="email"
            ></InputText>
            <label htmlFor="email">Por favor confirmar seu email</label>
          </span>
        </div>
        <div className="loginCheckbox" style={{ textAlign: "center" }}>
          <Checkbox
            inputId="binary"
            className="loginCheckbox pb-5"
            checked={checkedProtesto}
            onChange={(e) => setCheckedProtesto(e.checked)}
          />
          <label htmlFor="binary" className="text-[2vh]">
            Estou ciente do estado atual da dívida que busco renegociar.
          </label>
        </div>
      </div>
    </Dialog>
  );
}

export default ProtestoDialog;
